// ---------------------------------------------------------------------------
// FEATURE FLAGS
// ---------------------------------------------------------------------------
// Hide not-yet-ready features from the live site without deleting any code.
// When your API keys are live (added to the BACKEND .env), flip the flag to
// `true` and redeploy — the nav link and page come straight back.
//
//   marketplace   -> eBay Browse API keys
//   vehicleCheck  -> DVLA (VES) + DVSA (MOT) API keys
//
// While a flag is false: the nav link is hidden and the route redirects home.
export const FEATURES = {
  marketplace: false,
  vehicleCheck: false,
};
